

























































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ModalDelete from '@/app/ui/components/ModalDelete/index'
import { NotificationModule } from '@/app/store/modules/notifications'
import ModalEdit from './ModalEdit.vue'
@Component({
  components: {
    'modal-delete': ModalDelete,
    'modal-edit': ModalEdit,
  },
})
export default class extends Vue {
  @Prop({}) public onPageLimit
  @Prop({}) public onPageNumChanged
  @Prop({}) public dataTable
  @Prop({}) public fields: any[] | undefined
  @Prop({}) public selected: any[] | undefined
  @Prop({}) public clearTableStatus
  @Prop({}) public isLoading

  @Watch('clearTableStatus')
  public onPropertyChanged(value: boolean, oldValue: boolean) {
    this.$refs.selectableTable.clearSelected()
  }

  // Form Edit
  public id: number = 0
  public title = ''
  public content = ''
  public deletable = 'false'

  // Validasi
  public get stateTitle(): boolean {
    return this.title.length >= 4 ? true : false
  }

  public get stateContent(): boolean {
    return this.content.length >= 4 ? true : false
  }

  public modalDelete = {
    id: 'modal-delete',
    notification_id: 0,
    title: '',
  }
  public $refs!: {
    selectableTable: HTMLFormElement
  }
  public funcDelete(item, index, button) {
    if (this.$props.selected.length < 1) {
      this.modalDelete.title = item.title
      this.modalDelete.notification_id = item.id
      this.$root.$emit('bv::show::modal', this.modalDelete.id, button)
    }
  }
  public funcEdit(item, index, button) {
    //  console.log('ITEM TO EDIT', item)
    this.id = item.id
    this.title = item.title
    this.content = item.content
    this.deletable = item.deletable
    this.$root.$emit('bv::show::modal', 'edit-notification', button)
  }

  public resetEditModal() {
    this.title = ''
    this.content = ''
    this.deletable = 'false'
  }
  public resetDeleteModal() {
    this.modalDelete.title = ''
  }
  public funcOke(item, index, button) {
    this.$root.$emit('bv::hide::modal', this.$data.modalDelete.id, button)
  }
  public onRowSelected(items) {
    this.$emit('onRowSelected', items)
  }
  public selectAllRows() {
    if (this.$props.selected.length === this.dataTable.data.length) {
      this.$refs.selectableTable.clearSelected()
    } else {
      this.$refs.selectableTable.selectAllRows()
    }
  }

  public get buttonDisabled(): boolean {
    return this.$props.selected.length >= 1 ? true : false
  }

  public async patchNotif(item, index, button) {
    const dataToEdit = {
      id: this.id,
      title: this.title,
      content: this.content,
      deletable: this.deletable,
    }
    NotificationModule.updateNotification(dataToEdit)
    this.$root.$emit('bv::hide::modal', 'edit-notification', button)
  }

  public deleteNotif() {
    const ids = [this.modalDelete.notification_id]
    NotificationModule.deleteNotification({ ids })
    this.$root.$emit('bv::hide::modal', 'modal-delete')
  }
}
